import { render, staticRenderFns } from "./PainterChat.vue?vue&type=template&id=5db1014c&scoped=true"
import script from "./PainterChat.vue?vue&type=script&lang=js"
export * from "./PainterChat.vue?vue&type=script&lang=js"
import style0 from "./PainterChat.vue?vue&type=style&index=0&id=5db1014c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db1014c",
  null
  
)

export default component.exports